// Changes the color of the Treemap squares dependant on the percentage change and time frame

const color = {
  colorNeutral: "#3F4C53",
  negativeStageThree: "#EE383A",
  negativeStageTwo: "#CE3E41",
  negativeStageOne: "#824450",
  positiveStageOne: "#3B5A50",
  positiveStageTwo: "#32904E",
  positiveStageThree: "#31CC5A",
};
export const percentageChecker = (num: number, timeFrame: string): string => {
  if (timeFrame === "Daily") {
    if (-0.25 <= num && num <= 0.25) {
      return color.colorNeutral;
    }
    if (-2.5 < num && num < -1) {
      return color.negativeStageOne;
    }
    if (-2.5 < num && num <= -5) {
      return color.negativeStageTwo;
    }
    if (num < -5) {
      return color.negativeStageThree;
    }
    if (num < 2.5 && num > 1) {
      return color.positiveStageOne;
    }
    if (num >= 2.5 && num < 5) {
      return color.positiveStageTwo;
    }
    if (num >= 5) {
      return color.positiveStageThree;
    }
  }
  if (timeFrame === "Weekly") {
    if (-0.5 <= num && num <= 0.5) {
      return color.colorNeutral;
    }
    if (-5 < num && num < -0.5) {
      return color.negativeStageOne;
    }
    if (-15 < num && num <= -5) {
      return color.negativeStageTwo;
    }
    if (num < -15) {
      return color.negativeStageThree;
    }
    if (num <= 5 && num > 0.5) {
      return color.positiveStageOne;
    }
    if (num < 15 && num > 5) {
      return color.positiveStageTwo;
    }
    if (num >= 15) {
      return color.positiveStageThree;
    } else {
      return color.colorNeutral;
    }
  }

  if (timeFrame === "Monthly") {
    if (-0.5 <= num && num <= 0.5) {
      return color.colorNeutral;
    }
    if (-10 < num && num < -0.5) {
      return color.negativeStageOne;
    }
    if (-20 < num && num <= -10) {
      return color.negativeStageTwo;
    }
    if (num < -20) {
      return color.negativeStageThree;
    }
    if (num <= 10 && num > 0.5) {
      return color.positiveStageOne;
    }
    if (num < 20 && num > 10) {
      return color.positiveStageTwo;
    }
    if (num >= 20) {
      return color.positiveStageThree;
    } else {
      return color.colorNeutral;
    }
  }
  return color.colorNeutral;
};

// Styling for the upper labels and borders of treemap
export const getLevelOption = () => {
  return [
    {
      color: "#002035",
      //----------------outer border----------
      itemStyle: {
        borderColor: "#002035",
        borderWidth: 10,
        backgroundColor: "#002035",
        gapWidth: 1,
        upperLabel: {
          backgroundColor: "#002035",
          borderWidth: 0,
          gapWidth: 0,
        },
      },
    },

    {
      upperLabel: {
        show: true,
        height: 19,
        borderColor: "#002035",
        fontSize: 20,
        color: "#F8F9F9",
        fontWeight: "bold",
        fontFamily: "Roobert",
        lineHeight: 10,
      },

      itemStyle: {
        color: "#002035",
        //-------------------------- Main Category  squares
        backgroundColor: "#002035",
        borderColor: "#002035",
        borderWidth: 2,
        gapWidth: 2,
      },

      emphasis: {
        upperLabel: {
          color: "#002035",
          borderColor: "#F8F9F9",
        },
        itemStyle: {
          borderColor: "#F8F9F9",
        },
      },
    },
    {
      colorSaturation: [0.15, 0.1],
      itemStyle: {
        //-------------------------- Individual squares
        borderWidth: 1,
        backgroundColor: "#002035",
        gapWidth: 1,
        borderColor: "#002035",
        borderColorSaturation: 0,
      },
      upperLabel: {
        show: true,
        color: "#F8F9F9",
        borderColor: "#002035",
        backgroundColor: "#002035",
      },
      emphasis: {
        upperLabel: {
          color: "#002035",
          borderColor: "#F8F9F9",
          backgroundColor: "#F8F9F9",
          fontWeight: "bold",
        },
        itemStyle: {
          borderColor: "#F8F9F9",
        },
      },
    },
  ];
};
// Treemap percentage color legend.
export const percentageDaily = [
  { amount: "-5% ", color: color.negativeStageThree },
  { amount: "-2.5% ", color: color.negativeStageTwo },
  { amount: "-1% ", color: color.negativeStageOne },
  { amount: "-0% ", color: color.colorNeutral },
  { amount: "+1% ", color: color.positiveStageOne },
  { amount: "+2.5% ", color: color.positiveStageTwo },
  { amount: "+5% ", color: color.positiveStageThree },
];
export const percentageWeekly = [
  { amount: "-20% ", color: color.negativeStageThree },
  { amount: "-15% ", color: color.negativeStageTwo },
  { amount: "-5% ", color: color.negativeStageOne },
  { amount: "-0% ", color: color.colorNeutral },
  { amount: "+1% ", color: color.positiveStageOne },
  { amount: "+15% ", color: color.positiveStageTwo },
  { amount: "+20% ", color: color.positiveStageThree },
];
export const percentageMonthly = [
  { amount: "-30% ", color: color.negativeStageThree },
  { amount: "-20% ", color: color.negativeStageTwo },
  { amount: "-10% ", color: color.negativeStageOne },
  { amount: "-0% ", color: color.colorNeutral },
  { amount: "+10% ", color: color.positiveStageOne },
  { amount: "+20% ", color: color.positiveStageTwo },
  { amount: "+30% ", color: color.positiveStageThree },
];
